import React, { useState, useEffect } from 'react'
import { withTheme } from 'styled-components'
import { Flex, FlexColumn, LightContainer } from '../../Reusable/Container';
import { Text } from '../../Reusable/Text';
import { Image } from '../../Reusable/Image';
import { TextButton, ImageButton } from '../../Reusable/Button';
import { addressObjectToStr } from '../../../Utils/util'
import ModalClose from '../../../Images/modal-close.png'

const BankDetails = ({ paymentMethod, width, theme }) => {
    const [isVisible, setIsVisible] = useState(false)

    const { bankDetail, remittanceInfo } = paymentMethod
    const { internationalPaymentDetails } = bankDetail

    return (
        <>
            {
                isVisible ?
                    <LightContainer padding="16px" border radius="8px" width={width || "100%"}>
                        <Flex between fullWidth>
                            <Text heading>Bank details</Text>
                            <ImageButton src={ModalClose} onClick={() => setIsVisible(false)} />
                        </Flex>
                        <FlexColumn start gap="10px" style={{ marginTop: 18 }}>
                            <FlexColumn gap="8px">
                                {bankDetail.bankName && <Flex between>
                                    <Text color='#4F4F78'>Bank Name</Text>
                                    <Flex gap="8px">
                                        {bankDetail.logoUrl && <Image src={bankDetail.logoUrl} height="20px" width="20px" />}
                                        <Text color={theme.colors.primary2}>{bankDetail.bankName || 'N/A'}</Text>
                                    </Flex>
                                </Flex>}
                                {bankDetail.routingNumber && <Flex between>
                                    <Text color='#4F4F78'>Routing Number</Text>
                                    <Text color={theme.colors.primary2}>{bankDetail.routingNumber}</Text>
                                </Flex>}
                                {internationalPaymentDetails?.routingCodeValue1 &&
                                    <Flex between>
                                        <Text color='#4F4F78'>{internationalPaymentDetails?.routingCodeType1?.replace(/([a-z])([A-Z])/g, '$1 $2')}</Text>
                                        <Text color={theme.colors.primary2}>{internationalPaymentDetails?.routingCodeValue1}</Text>
                                    </Flex>
                                }
                                {internationalPaymentDetails?.routingCodeValue2 &&
                                    <Flex between>
                                        <Text color='#4F4F78'>{internationalPaymentDetails?.routingCodeType2?.replace(/([a-z])([A-Z])/g, '$1 $2')}</Text>
                                        <Text color={theme.colors.primary2}>{internationalPaymentDetails?.routingCodeValue2}</Text>
                                    </Flex>
                                }
                                {bankDetail.accountNumber && <Flex between>
                                    <Text color='#4F4F78'>Account Number</Text>
                                    <Text color={theme.colors.primary2}>{bankDetail.accountNumber}</Text>
                                </Flex>}
                                {bankDetail.accountType && <Flex between>
                                    <Text color='#4F4F78'>Account Type</Text>
                                    <Text color={theme.colors.primary2}>{bankDetail.accountType}</Text>
                                </Flex>}
                                {
                                    bankDetail?.addressOnAccount &&
                                    <Flex between>
                                        <Text color='#4F4F78'>Recipient Address</Text>
                                        <Text color={theme.colors.primary2}>{addressObjectToStr(bankDetail?.addressOnAccount)}</Text>
                                    </Flex>
                                }
                                {
                                    remittanceInfo &&
                                    <Flex between>
                                        <Text color='#4F4F78'>Remittance Information</Text>
                                        <Text color={theme.colors.primary2}>{remittanceInfo}</Text>
                                    </Flex>
                                }
                                {
                                    internationalPaymentDetails?.bicSwift &&
                                    <Flex between>
                                        <Text color='#4F4F78'>SWIFT</Text>
                                        <Text color={theme.colors.primary2}>{internationalPaymentDetails?.bicSwift}</Text>
                                    </Flex>
                                }
                                {
                                    internationalPaymentDetails?.iban &&
                                    <Flex between>
                                        <Text color='#4F4F78'>IBAN</Text>
                                        <Text color={theme.colors.primary2}>{internationalPaymentDetails?.iban}</Text>
                                    </Flex>
                                }
                            </FlexColumn>
                        </FlexColumn>
                    </LightContainer>
                    :
                    <TextButton underline weight='400' color="#4F4F7B" text="View bank details" onClick={() => setIsVisible(true)} />
            }
        </>
    );
};

export default withTheme(BankDetails);
